export function getJwtExpiry(token: string | null): number | null {
  if (!token) return null;
  try {
    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);
    return payload.exp; // Unix timestamp in seconds
  } catch (e) {
    console.error("Invalid JWT", e);
    return null;
  }
}

export function isValidJwt(token: string | null): boolean {
  const expiry = getJwtExpiry(token);
  if (expiry === null) return false; // If we can't determine expiry, consider it invalid
  return Date.now() < expiry * 1000; // Convert seconds to milliseconds
}
